import sortOptions, { type SortOption, sortParams } from "./options";

type SortParam = (typeof sortParams)[keyof typeof sortParams];

const resolveSortParam = (
  sort: SortOption,
  featuredSortVariant: string,
): SortParam => {
  if (sort === sortOptions.FEATURED_NEW_TOP) {
    // Hosts supply backend enum values directly so experiments do not require store releases.
    return (featuredSortVariant || sortParams.FEATURED_NEW_TOP) as SortParam;
  }

  return sortParams[sort];
};

export default resolveSortParam;
